var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "white",
    stroke: "#172664",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChecked);
export default __webpack_public_path__ + "static/media/icn_checked.3a082addd258eadad381343e32bd7438.svg";
export { ForwardRef as ReactComponent };